import { render, staticRenderFns } from "./CommonSendCode.vue?vue&type=template&id=ccb91496&scoped=true"
import script from "./CommonSendCode.vue?vue&type=script&lang=js"
export * from "./CommonSendCode.vue?vue&type=script&lang=js"
import style0 from "./CommonSendCode.vue?vue&type=style&index=0&id=ccb91496&prod&lang=scss&scoped=true"
import style1 from "./CommonSendCode.vue?vue&type=style&index=1&id=ccb91496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb91496",
  null
  
)

export default component.exports